import { __module as e } from "../../../_virtual/isEmail.js";
import { a as t } from "./util/assertString.js";
import { m as r } from "./util/merge.js";
import { i as a } from "./isByteLength.js";
import { i } from "./isFQDN.js";
import { i as l } from "./isIP.js";
!function (e, s) {
  Object.defineProperty(s, "__esModule", {
    value: !0
  }), s.default = function (e, t) {
    if ((0, u.default)(e), (t = (0, o.default)(t, d)).require_display_name || t.allow_display_name) {
      var r = e.match(m);
      if (r) {
        var a,
          i,
          l = r[1];
        if (e = e.replace(l, "").replace(/(^<|>$)/g, ""), l.endsWith(" ") && (l = l.substr(0, l.length - 1)), !(i = (a = l).replace(/^"(.+)"$/, "$1")).trim() || /[\.";<>]/.test(i) && (i === a || i.split('"').length !== i.split('\\"').length)) return !1;
      } else if (t.require_display_name) return !1;
    }
    if (!t.ignore_max_length && e.length > 254) return !1;
    var s = e.split("@"),
      _ = s.pop(),
      b = _.toLowerCase();
    if (t.host_blacklist.includes(b)) return !1;
    var v = s.join("@");
    if (t.domain_specific_validation && ("gmail.com" === b || "googlemail.com" === b)) {
      var D = (v = v.toLowerCase()).split("+")[0];
      if (!(0, x.default)(D.replace(/\./g, ""), {
        min: 6,
        max: 30
      })) return !1;
      for (var $ = D.split("."), j = 0; j < $.length; j++) if (!c.test($[j])) return !1;
    }
    if (!1 === t.ignore_max_length && (!(0, x.default)(v, {
      max: 64
    }) || !(0, x.default)(_, {
      max: 254
    }))) return !1;
    if (!(0, f.default)(_, {
      require_tld: t.require_tld
    })) {
      if (!t.allow_ip_domain) return !1;
      if (!(0, n.default)(_)) {
        if (!_.startsWith("[") || !_.endsWith("]")) return !1;
        var w = _.substr(1, _.length - 2);
        if (0 === w.length || !(0, n.default)(w)) return !1;
      }
    }
    if ('"' === v[0]) return v = v.slice(1, v.length - 1), t.allow_utf8_local_part ? h.test(v) : F.test(v);
    for (var y = t.allow_utf8_local_part ? g : p, E = v.split("."), q = 0; q < E.length; q++) if (!y.test(E[q])) return !1;
    return !t.blacklisted_chars || -1 === v.search(RegExp("[".concat(t.blacklisted_chars, "]+"), "g"));
  };
  var u = _(t),
    o = _(r),
    x = _(a),
    f = _(i),
    n = _(l);
  function _(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  var d = {
      allow_display_name: !1,
      require_display_name: !1,
      allow_utf8_local_part: !0,
      require_tld: !0,
      blacklisted_chars: "",
      ignore_max_length: !1,
      host_blacklist: []
    },
    m = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i,
    p = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i,
    c = /^[a-z\d]+$/,
    F = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i,
    g = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i,
    h = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
  e.exports = s.default, e.exports.default = s.default;
}(e, e.exports);
var s = e.exports;
export { s as i };